export default __webpack_public_path__ + "static/media/Greenhouse_05.ff3de78c.webp";